import {Injectable} from "@angular/core";
import {UserService} from "@nordpoolgroup/nps-angular-2-common";
import {IBackupContractStatus, INPMContractStatus, IXBIDContractStatus} from "./IContractData";

@Injectable()
export class TenantService {
    static readonly NORDPOOL_TENANT_ID = "N";
    static readonly CROPEX_TENANT_ID = "A";
    static readonly EPEX_TENANT_ID = "C";
    static readonly IBEX_TENANT_ID = "B";
    static readonly GENEX_TENANT_ID = "D";
    static readonly BRM_TENANT_ID = "E";
    static readonly ELMA_TENANT_ID = "F";
    static readonly ENEXGROUP_TENANT_ID = "H";

    static readonly backupContractStatus: IBackupContractStatus[] = [
        {tenantId: "N", isBackupEnabled: true},
        {tenantId: "A", isBackupEnabled: true},
        {tenantId: "B", isBackupEnabled: false},
        {tenantId: "C", isBackupEnabled: false},
        {tenantId: "D", isBackupEnabled: false},
        {tenantId: "E", isBackupEnabled: true},
        {tenantId: "F", isBackupEnabled: false},
        {tenantId: "H", isBackupEnabled: false}
    ];

    static readonly NPMContractStatus: INPMContractStatus[] = [
        {tenantId: "N", isNPMEnabled: true},
        {tenantId: "A", isNPMEnabled: false},
        {tenantId: "B", isNPMEnabled: false},
        {tenantId: "C", isNPMEnabled: false},
        {tenantId: "D", isNPMEnabled: true},
        {tenantId: "E", isNPMEnabled: false},
        {tenantId: "F", isNPMEnabled: true},
        {tenantId: "H", isNPMEnabled: false}
    ];

    static readonly XBIDContractStatus: IXBIDContractStatus[] = [
        {tenantId: "N", isXBIDEnabled: true},
        {tenantId: "A", isXBIDEnabled: true},
        {tenantId: "B", isXBIDEnabled: true},
        {tenantId: "C", isXBIDEnabled: false},
        {tenantId: "D", isXBIDEnabled: false},
        {tenantId: "E", isXBIDEnabled: true},
        {tenantId: "F", isXBIDEnabled: false},
        {tenantId: "H", isXBIDEnabled: true}
    ];

    isXbidTenant = false;
    currentTenantId: string;

    constructor(
        private userService: UserService) {
        this.currentTenantId = this.userService.user.availableTenants[0];
        this.isXbidTenant = this.isXbid(this.userService.user.availableTenants[0]);
    }

    isXbid(tenantId: string): boolean {
        return tenantId !== TenantService.GENEX_TENANT_ID && tenantId !== TenantService.ELMA_TENANT_ID;
    }

    isNordpoolTenant(): boolean {
        return TenantService.NORDPOOL_TENANT_ID === this.currentTenantId;
    }

    isBackupContractsEnabledForCurrentTenant(): boolean {
        const backupContractStatus = TenantService.backupContractStatus.find(obj => {
            return obj.tenantId === this.currentTenantId;
        });
        return backupContractStatus.isBackupEnabled;
    }

    isNPMContractsEnabledForCurrentTenant(): boolean {
        const npmContractStatus = TenantService.NPMContractStatus.find(obj => {
            return obj.tenantId === this.currentTenantId;
        });
        return npmContractStatus.isNPMEnabled;
    }

    isXBIDContractsEnabledForCurrentTenant(): boolean {
        const xbidContractStatus = TenantService.XBIDContractStatus.find(obj => {
            return obj.tenantId === this.currentTenantId;
        });
        return xbidContractStatus.isXBIDEnabled;
    }

    getAllTenants(): string[] {
        return [TenantService.NORDPOOL_TENANT_ID, TenantService.CROPEX_TENANT_ID, TenantService.BRM_TENANT_ID];
    }
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/Services/TenantService.ts